import { render, staticRenderFns } from "./MailAction.vue?vue&type=template&id=0471a8f8"
import script from "./MailAction.vue?vue&type=script&lang=js"
export * from "./MailAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports